module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [(_vm.instructions.length > 0) ? _c('div', {
    staticClass: "alert alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(1), _vm._v(" "), _c('strong', [_c('ol', _vm._l((_vm.instructions), function(instruction) {
    return _c('li', [_vm._v(_vm._s(instruction))])
  }))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default panel-height",
    attrs: {
      "id": "panelChart9"
    }
  }, [_vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "top-margin"
  }, [_vm._v("Please input the two micro-deposited amounts that we have made on your bank account: ")]), _vm._v(" "), _c('form', {
    staticClass: "mb-lg top-margin",
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitVerifyMicroDeposit($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "amount1"
    }
  }, [_vm._v("Amount 1")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.microDeposit.requestBody.amount1.value),
      expression: "microDeposit.requestBody.amount1.value"
    }],
    staticClass: "form-control",
    attrs: {
      "step": "0.0001",
      "type": "number",
      "id": "amount1",
      "placeholder": "Micro Deposit - Amount 1",
      "required": ""
    },
    domProps: {
      "value": (_vm.microDeposit.requestBody.amount1.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.microDeposit.requestBody.amount1.value = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "amount2"
    }
  }, [_vm._v("Amount 2")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.microDeposit.requestBody.amount2.value),
      expression: "microDeposit.requestBody.amount2.value"
    }],
    staticClass: "form-control",
    attrs: {
      "step": "0.0001",
      "type": "number",
      "id": "amount2",
      "placeholder": "Micro Deposit - Amount 2",
      "required": ""
    },
    domProps: {
      "value": (_vm.microDeposit.requestBody.amount2.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.microDeposit.requestBody.amount2.value = $event.target.value
      }
    }
  })])])]), _vm._v(" "), (_vm.verifyError.length !== 0 || _vm.amountError.length !== 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('strong', [_c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.verifyError))])]), _vm._v(" "), _c('strong', [_c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.amountError))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg button-submit",
    attrs: {
      "type": "submit",
      "disabled": _vm.microDeposit.fundingSourceId.length === 0 || _vm.maxAttempsReached
    }
  }, [_vm._v("Submit")])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      Micro Deposits\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('em', {
    staticClass: "icon-exclamation pr-sm"
  }), _vm._v("Please take the following steps to retry bank account verification via micro deposit:")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "accounts-title"
  }, [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n              Micro Deposits - Verifications\n            ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12dc227c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MicroDepositsVerification.vue
// module id = 2107
// module chunks = 1